import styled from 'styled-components'

import { getResponsiveFontSizeCSS } from 'helpers/css'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 41px;
    font-family: inherit;
    background: ${props => props.bgColor};
    border-radius: 18px;
`

export const Content = styled.div`
    width: 100%;
    height: 21.5vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
`

export const Title = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: ${getResponsiveFontSizeCSS(18, 24)};
    letter-spacing: -0.0075em;
    color: #555555;
`

export const Body = styled.div`
    width: 90%;
    font-style: normal;
    font-weight: 400;
    font-size: ${getResponsiveFontSizeCSS(16, 18)};
    line-height: 25px;
    letter-spacing: -0.005em;
    text-transform: lowercase;
    color: #555555;
    margin: 9px 0px 13px 0px;
`

export const Cta = styled.a`
    padding: 6px 35px;
    width: fit-content;
    background: #66b5de; /* dull blue */
    border-radius: 5px;
    outline: none;
    border: none;
    text-align: center;
    color: #f2f2f2;
    font-weight: 800;
    font-size: ${getResponsiveFontSizeCSS(12, 14)};
    line-height: 25px;
    cursor: ${({ href }) => (href ? 'pointer' : 'default')};
    text-decoration: none;
`
export const Image = styled.img``

export const ImageWrapper = styled.div``
